import React, { useState, useEffect } from "react";
import { getListForCustomer } from "../../clientServices/previewStore";
import { StatusTrans, moneyFormat } from "../../ultil";
import moment from "moment";

import InputCustom from "../Input/InputCustom";
import TextTitle from "../Text/TextTitle";
import TextTitle1 from "../Text/TextTitle1";
import TextBody from "../Text/TextBody";
import TextBody2 from "../Text/TextBody2";
import TextHead from "../Text/TextHead";
import TextPrice from "../Text/TextPrice";
import TextPriceOld from "../Text/TextPriceOld";
import TextQuantity from "../Text/TextQuantity";
import TextOutOfStock from "../Text/TextOutOfStock";
import Modal from "react-modal";
import { modalStyleBottom, modalStyleDetail, style } from "../../style";
import { useTheme, styled } from '@mui/material/styles';
import {
  AppBar,
  Box,
  Divider,
  IconButton,
  Button,
  ButtonBase,
  ButtonGroup,
  Toolbar,
  Tab,
  Tabs,
  Slide,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  Radio,
  Grid,
} from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function ListOrder({
  listOrderUser,
  setIdFiterOrder,
  idFiterOrder,
  setIdDetailOrder,
  limitOrder,
  setLimitOrder,
  btnOrderHistory,
  btnCancelOrder
}) {
  const dataFiter = [
    {
      name: "Tất cả",
      id: "",
    },
    {
      name: "Đã xong",
      id: 4,
    },
    {
      name: "Huỷ",
      id: 5,
    },
  ];
  const btnFiter = (data) => {
    setIdFiterOrder(data.id);
  };
  const getDetailOrder = (data) => {
    setIdDetailOrder(data._id);
  };

  return (
    <Box sx={{ position: 'relative', bgcolor: '#f0f0f0'}}>
    <AppBar
      position="sticky"
      color="inherit"
    >
      <Toolbar sx={{minHeight: '52px'}}>
        <TextTitle1 sx={{flexGrow: 1, textAlign: 'center'}} variant="h5" component="div">
          Lịch sử
        </TextTitle1>
      </Toolbar>
    </AppBar>
    {listOrderUser.length ? (
      listOrderUser.map((item, index) => {
        return (<Box onClick={() => getDetailOrder(item)} key={index} p={2} mt={1} bgcolor="#ffffff" sx={{cursor: 'pointer'}}>
          <Box mb={2} sx={{display: 'flex'}}>
          <Box>
          {item.store ? (
            <img
              style={{ width: '110px', height: '100px', borderRadius: '16px' }}
              src={item.store.image}
            ></img>
          ) : null}
          </Box>
          <Box ml={2} sx={{flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
            <Box>
              <TextBody2>{StatusTrans(item.status, item.deliveryType)} #{item.code} </TextBody2>
              <TextBody className="line-clamp-2">{item.store.name} {item.store.name} {item.store.name} {item.store.name}</TextBody>
            </Box>
            <TextBody2 color="#929394">{moment(item.updatedAt).format("DD/MM HH:mm")}</TextBody2>
          </Box>
          </Box>
          <Divider/>
          <Box mt={1} sx={{display: 'flex'}}>
            <Box sx={{flexGrow: 1}}>
            <TextBody2>{moneyFormat(item.money + (item.discountMoneyDeposit || 0))}</TextBody2>
            <TextBody2>{item.cart.length} sản phẩm</TextBody2>
            </Box>
            <Box>
            {
              [0].includes(_.get(item, 'status'))?
              <ButtonBase onClick={(e)=>{
                e.stopPropagation()
                btnCancelOrder(_.get(item, '_id'))
              }} variant="contained" sx={{fontSize: '14px', width: '100%', textTransform: 'none', bgcolor: '#e93940', color: '#ffffff', borderRadius: '8px', padding: '6px 16px'}}>
                Hủy đơn
              </ButtonBase>
              :
              [4,5].includes(_.get(item, 'status'))?
              <Button onClick={(e)=>{
                e.stopPropagation()
                btnOrderHistory(item)
              }} variant="contained" sx={{fontSize: '14px', textTransform: 'none', bgcolor: '#1589D8', borderRadius: '8px'}}>
                Đặt lại
              </Button>
              :null
            }
            </Box>
            

          </Box>
        </Box>);
      })

    ) : (
      <Box p={2}>
        <img
          style={{ width: "100%" }}
          src="/image/order-empty.png"
        />
        <TextBody mt={3} component="p" sx={{ fontSize: "26px", textAlign: 'center' }}>Bạn chưa có đơn nào</TextBody>
        <TextBody mt={2} component="p" color="#929394" sx={{textAlign: 'center'}}>Hãy bắt đầu đặt ngay đơn hàng đầu tiên bạn nhé!</TextBody>
      </Box>
    )}
    </Box>
  );
}
